import React, { useState } from "react";
import { PrimaryButton } from "../buttons/PrimaryButton";
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import {format, isBefore} from "date-fns";
import { UserProductsListResponse } from "../../api/requests/interfaces/Product";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import formatLimitedText from "../hooks/formatLimitedText";


export interface AdvertsCardProps {
    data: UserProductsListResponse,
}

export const AdvertsCard: React.FC<AdvertsCardProps> = (props) => {
    const [data] = useState<UserProductsListResponse>(props.data);
    const navigate = useNavigate();

    return (
        <div className="rounded-lg shadow-main p-2 lg:p-5">

            <div className="flex flex-col lg:flex-row gap-3 relative">
                <div className="flex flex-row w-full">
                    <img className="w-[150px] aspect-square h-[150px] object-contain rounded-md flex-none" src={data.pictureUrl}></img>
                    <div className="w-full flex flex-col text-left border-l-[2px] border-primary_lighter pl-2">
                        <h3 className="pb-1">{formatLimitedText(20, data.title)}</h3>
                        <div>ID: #{data.id}</div>
                        <div className="flex flex-row items-center mt-2 text-sm">
                            <PlaceOutlinedIcon style={{ width: "22px", height: "22px" }} />
                            <div className="pl-1">{formatLimitedText(10, data.location)}</div>
                        </div>
                    </div>
                </div>
                <div className="w-full flex flex-row gap-2">
                    <div className="basis-2/3 lg:min-w-[140px] flex flex-row lg:flex-col gap-2 text-left lg:border-l-[2px] border-primary_lighter pl-2">
                        <div>
                            <h4 className="">Algus</h4>

                            <div className="flex flex-row items-center text-sm">
                                <CalendarTodayOutlinedIcon style={{ width: "22px", height: "22px" }} />
                                <div className="pl-2">{format(new Date(data.createdAt) , "dd/MM/yyyy, HH:mm")}</div>
                            </div>
                        </div>
                        <div>
                            <h4 className="">Lõpp</h4>

                            <div className="flex flex-row items-center text-sm">
                                <CalendarTodayOutlinedIcon style={{ width: "22px", height: "22px" }} />
                                <div className="pl-2">{format(new Date(data.visibleUntilDate) , "dd/MM/yyyy, HH:mm")}</div>
                            </div>
                        </div>

                    </div>

                    <div className="basis-1/3 flex flex-col gap-2 text-start lg:mt-0 lg:border-l-[2px] border-primary_lighter pl-2">
                        <div className="flex flex-col gap-3">
                            <div className="">
                                <h4>Hind:</h4>
                                <div className="text-xl font-bold flex flex-row">{data.dailyPrice}
                                    <div className="font-light text-sm pl-1">€/paev</div>
                                </div>
                                {/* {window.innerWidth > 1024 &&
                                    <div className="text-left w-full pt-2 flex flex-col gap-2 justify-start">
                                        {data.status !== RentalStatus.AD_CREATED ?
                                            <PrimaryButton icon={<MailOutlineIcon style={{ width: "24px", height: "24px" }} />} title="Sõnumitesse" onClick={() => { }} widthFit={true}></PrimaryButton>
                                            : ""}
                                        <PrimaryButton title="Toote lehele" onClick={() => { }} widthFit={true} outlined={true}></PrimaryButton>
                                    </div>
                                } */}
                            </div>

                        </div>

                    </div>
                </div>
                {
                    isBefore(data.visibleUntilDate, new Date()) &&
                    <div className="absolute z-20 w-full h-full bg-gray-300/40 rounded-md flex justify-center items-center">
                        <div className="text-orange-500 font-bold text-2xl">Aegunud</div>
                    </div>
                }
            </div>
            <div className="text-left min-w-[120px] pt-2 flex flex-row gap-2 justify-start">
                <div className="md:max-w-[300px] w-full">
                    <PrimaryButton icon={<EditIcon style={{ width: "24px", height: "24px" }} />}
                                   title={isBefore(data.visibleUntilDate, new Date()) ? "Pikenda kuulutust" : "Muuda"}
                                   onClick={() => { navigate('/edit?type=edit&id=' + data.id.toString()) }}
                                   widthFit={false}></PrimaryButton>
                </div>
                {
                    !isBefore(data.visibleUntilDate, new Date()) &&
                        <PrimaryButton title="Toote lehele"
                                       onClick={() => { navigate('/detail/' + data.id.toString()) }}
                                       widthFit={false} outlined={true}></PrimaryButton>
                }
            </div>

        </div>
    )
}